export const EventType = {
    PaddockMoved: 'com.farmote.api.PaddockMoved',
    PaddockMoveDeleted: 'com.farmote.api.PaddockMoveDeleted',
    ZoneGrazed: 'com.farmote.api.ZoneGrazed',
    ZoneGrazeDeleted: 'com.farmote.api.ZoneGrazeDeleted',
};
